$.fn.NavIndicator = function()
{
  var self = this;
  self.currentStage = undefined;
  self.ghost = undefined;

  self.el = {
    section: self.find('.indicator__section'),
    subsection: self.find('.indicator__subsection'),
    title: self.find('.indicator__title'),
    subtitle: self.find('.indicator__subtitle'),
    bullets: self.find('.indicator__bullets'),
  };

  self.cell = {
    section: self.find('.section-value'),
    subsection: self.find('.subsection-value'),
    title: self.find('.title-value'),
    subtitle: self.find('.subtitle-value'),
  }

  self.status = {
    initialized: false,
  };

  self.setScroller = function(newScroller)
  {
    if (self.currentStage != undefined){
      self.currentStage.scroller.off("currentSection", self.sectionChanged);
      self.currentStage.scroller.off("scrolled", self.scrollerScrolled);
    }
    self.currentStage = newScroller;
    self.currentStage.scroller.on("currentSection", self.sectionChanged);
    self.currentStage.scroller.on("scrolled", self.scrollerScrolled);
  };

  self.sectionChanged = function()
  {
    let currentSection = $(self.currentStage.getCurrentSection()),
      currentSectionData = currentSection.data('nav');
    if (currentSectionData){
      self.setData(currentSectionData);
    }
  };

  self.scrollerScrolled = function()
  {
    let indicatorRect = self.get(0).getBoundingClientRect(),
      intersects = {
        desktop: false,
        mobile: false,
      };
    self.currentStage.scroller.find(".page--home, .page--credits").each(function(){
      let elementRect = $(this).get(0).getBoundingClientRect();
      var overlap = !(indicatorRect.right < elementRect.left || indicatorRect.left > elementRect.right || indicatorRect.bottom < elementRect.top || indicatorRect.top > elementRect.bottom);
      if (overlap){
        intersects.desktop = true;
        intersects.mobile = true;
        return false;
      }
    });
    self.currentStage.scroller.find(".article__banner img, img.article__banner").each(function(){
      let elementRect = $(this).get(0).getBoundingClientRect();
      var overlap = !(indicatorRect.right < elementRect.left || indicatorRect.left > elementRect.right || indicatorRect.bottom < elementRect.top || indicatorRect.top > elementRect.bottom);
      if (overlap){
        intersects.desktop = true;
        return false;
      }
    });
    if (intersects.desktop){
      self.addClass("indicator--intersects-desktop");
    } else {
      self.removeClass("indicator--intersects-desktop");
    }
    if (intersects.mobile){
      self.addClass("indicator--intersects-mobile");
    } else {
      self.removeClass("indicator--intersects-mobile");
    }
  };

  self.setData = function(data)
  {
    // direction
    let oldSectionIndex = parseInt(self.ghost.cell.section.text(), 10),
      oldSubsectionIndex = parseInt(self.ghost.cell.subsection.text(), 10),
      newSectionIndex = parseInt(data.section, 10),
      newSubsectionIndex = parseInt(data.subsection, 10),
      direction = "down";
    if (isNaN(oldSectionIndex)) oldSectionIndex = 0;
    if (isNaN(oldSubsectionIndex)) oldSubsectionIndex = 0;
    if (isNaN(newSectionIndex)) newSectionIndex = 0;
    if (isNaN(newSubsectionIndex)) newSubsectionIndex = 0;
    if (newSectionIndex < oldSectionIndex){
      direction = "up";
    } else if (newSectionIndex == oldSectionIndex && newSubsectionIndex < oldSubsectionIndex){
      direction = "up";
    }

    // display data
    self.ghost.displayData(data);
    self.animateData(data, direction);
  };

  self.transitionCells = function(oldCell, newCell, direction)
  {
    oldCell.animate({
      opacity: 0,
      top: direction == "up" ? "5px" : "-5px",
    }, 75, "swing", function(){
      oldCell.replaceWith(newCell.css({
        top: direction == "up" ? "-5px" : "5px",
      }).fadeIn(75).animate({
        top: "0px",
      }, 75, "swing"));
    });
  };

  self.animateData = function(data, direction)
  {
    if (!self.status.initialized){
      self.displayData(data);
      self.addClass("indicator--animated");
      self.status.initialized = true;
    } else
    {
      // section
      if (self.cell.section.text() != self.ghost.cell.section.text()){
        let oldCell = self.cell.section, newCell = oldCell.clone();
        self.cell.section = newCell.text(self.ghost.cell.section.text());
        self.transitionCells(oldCell, self.cell.section, direction);
      }

      // subsection
      if (!self.el.subsection.is(":visible") && self.ghost.el.subsection.is(":visible")){
        self.cell.subsection.text(self.ghost.cell.subsection.text());
        self.el.subsection.fadeIn(150);
      } else if (self.el.subsection.is(":visible") && !self.ghost.el.subsection.is(":visible")){
        self.el.subsection.fadeOut(150);
      } else if (self.el.subsection.is(":visible") && self.ghost.el.subsection.is(":visible")){
        if (self.cell.subsection.text() != self.ghost.cell.subsection.text()){
          let oldCell = self.cell.subsection, newCell = oldCell.clone();
          self.cell.subsection = newCell.text(self.ghost.cell.subsection.text());
          self.transitionCells(oldCell, self.cell.subsection, direction);
        }
      }

      // title
      if (self.cell.title.text() != self.ghost.cell.title.text()){
        let oldCell = self.cell.title, newCell = oldCell.clone();
        self.cell.title = newCell.text(self.ghost.cell.title.text());
        self.transitionCells(oldCell, self.cell.title, direction);
      }

      // subtitle
      if (!self.el.subtitle.is(":visible") && self.ghost.el.subtitle.is(":visible")){
        self.cell.subtitle.text(self.ghost.cell.subtitle.text());
        self.el.subtitle.slideDown(150);
      } else if (self.el.subtitle.is(":visible") && !self.ghost.el.subtitle.is(":visible")){
        self.el.subtitle.slideUp(150);
      } else if (self.el.subtitle.is(":visible") && self.ghost.el.subtitle.is(":visible")){
        if (self.cell.subtitle.text() != self.ghost.cell.subtitle.text()){
          let oldCell = self.cell.subtitle, newCell = oldCell.clone();
          self.cell.subtitle = newCell.text(self.ghost.cell.subtitle.text());
          self.transitionCells(oldCell, self.cell.subtitle, direction);
        }
      }

      // bullets
      if (!self.el.bullets.is(":visible") && self.ghost.el.bullets.is(":visible")){
        self.el.bullets.html(self.ghost.el.bullets.html());
        self.el.bullets.slideDown(150);
      } else if (self.el.bullets.is(":visible") && !self.ghost.el.bullets.is(":visible")){
        self.el.bullets.slideUp(150);
      } else if (self.el.bullets.is(":visible") && self.ghost.el.bullets.is(":visible")){
        let bulletIndex = self.ghost.el.bullets.find(".bullet--current").index();
        self.el.bullets.find("span").removeClass("bullet--current");
        if ((bulletIndex || bulletIndex === 0) && bulletIndex > -1){
          self.el.bullets.find("span").eq(bulletIndex).addClass("bullet--current");
        }
      }
    }
  };

  self.displayData = function(data)
  {
    // mandatory
    self.cell.section.text(data.section);
    self.cell.title.text(data.title);

    // optional subsection
    if (data.subsection){
      self.el.subsection.show();
      self.cell.subsection.text(data.subsection);
    } else {
      self.el.subsection.hide();
      self.cell.subsection.text("");
    }

    // optional subtitle
    if (data.subtitle){
      self.el.subtitle.show();
      self.cell.subtitle.text(data.subtitle);
    } else {
      self.el.subtitle.hide();
      self.cell.subtitle.text("");
    }

    // optional bullets
    if (data.bullets){
      self.el.bullets.empty().show();
      for (var i = 1; i <= data.bullets; i++){
        let bullet = $('<span class="bullet">');
        if (data.bullet && data.bullet == i){
          bullet.addClass("bullet--current");
        }
        self.el.bullets.append(bullet);
      }
    } else {
      self.el.bullets.empty().hide();
    }
  };

  return function(){
    return self;
  }();
};

export default class NavIndicator {

  constructor(selector) {
    this.selector = selector;
  }

  init() {
    this.indicator = $(this.selector).NavIndicator();
    this.ghost = this.indicator.clone().NavIndicator();
    this.indicator.ghost = this.ghost;
    this.ghost.addClass("indicator--ghost");
    $("body").append(this.ghost);
  }

  setCurrentStage(scroller) {
    this.indicator.setScroller(scroller);
    this.indicator.sectionChanged();
    this.indicator.scrollerScrolled();
  }

  getCurrentStage() {
    return this.indicator.currentStage;
  }

}
